import { render, staticRenderFns } from "./StepTestimonial.vue?vue&type=template&id=4ef5bdb9"
import script from "./StepTestimonial.vue?vue&type=script&lang=js"
export * from "./StepTestimonial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports